import React, { PureComponent } from "react";

class Ticker extends PureComponent {
  getStockItems = (widget) => {
    if (Array.isArray(widget?.stockData) && widget.stockData.length) {
      return widget.stockData.filter((item) => item?.data);
    }

    if (!widget?.stockData) return [];

    const fallbackSymbol =
      widget?.data?.symbol ||
      widget?.stockData?.["Meta Data"]?.["2. Symbol"] ||
      widget?.stockData?.["Meta Data"]?.["1. Symbol"];

    if (!fallbackSymbol) return [];

    return [
      {
        symbol: fallbackSymbol,
        companyName: widget?.data?.companyName || fallbackSymbol,
        data: widget.stockData,
      },
    ];
  };

  getLatestStockData = (stockData) => {
    if (!stockData) return null;

    const timeSeriesKeys = Object.keys(stockData).filter(
      (key) => key.includes("Time Series") || key.includes("Meta Data")
    );

    if (timeSeriesKeys.length === 0) return null;

    const timeSeriesKey = timeSeriesKeys.find((key) =>
      key.includes("Time Series")
    );
    if (!timeSeriesKey) return null;

    const timeSeries = stockData[timeSeriesKey];
    if (!timeSeries) return null;

    const timestamps = Object.keys(timeSeries).sort().reverse();
    if (timestamps.length === 0) return null;

    const latestTimestamp = timestamps[0];
    const latestData = timeSeries[latestTimestamp];
    const previousTimestamp = timestamps[1] || null;
    const previousData = previousTimestamp
      ? timeSeries[previousTimestamp]
      : null;

    const metaData = stockData["Meta Data"] || {};
    const symbol = metaData["2. Symbol"] || metaData["1. Symbol"] || "";

    const currentClose = parseFloat(
      latestData["4. close"] ||
        latestData["4. Close"] ||
        latestData["5. adjusted close"] ||
        latestData["5. Adjusted Close"] ||
        0
    );
    const previousClose = previousData
      ? parseFloat(
          previousData["4. close"] ||
            previousData["4. Close"] ||
            previousData["5. adjusted close"] ||
            previousData["5. Adjusted Close"] ||
            currentClose
        )
      : parseFloat(
          latestData["1. open"] || latestData["1. Open"] || currentClose
        );

    return {
      symbol,
      timestamp: latestTimestamp,
      close: currentClose,
      previousClose: previousClose,
    };
  };

  render() {
    const widget = this.props.widget;
    const fontSize = this.props.fontSize;
    const stockItems = this.getStockItems(widget);

    if (!stockItems.length) return null;

    const itemsToRender = stockItems
      .map(
        function (item) {
          const data = this.getLatestStockData(item.data);
          if (!data) return null;
          const change = data.close - data.previousClose;
          const isPositive = change >= 0;

          return {
            name: item.companyName || item.symbol,
            price: data.close.toFixed(2),
            change: change.toFixed(2),
            isPositive: isPositive,
          };
        }.bind(this)
      )
      .filter(Boolean);

    if (itemsToRender.length === 0) return null;

    const bgColor = widget.data.bgColor || "#000000";
    const color = widget.data.color || "#ffffff";
    const profitColor = widget.data.profitColor || "#10b981";
    const lossColor = widget.data.lossColor || "#ef4444";

    const height = window.innerHeight;
    const width = window.innerWidth;
    const isSmallHeight = height < 200;
    const isSmallWidth = width < 400;

    const responsiveFontSize =
      isSmallHeight || isSmallWidth
        ? Math.min(height * 0.4, width * 0.08)
        : fontSize || Math.min(height * 0.7, width * 0.06);

    const gapSize = isSmallHeight || isSmallWidth ? "3rem" : "5rem";
    const marginSize = isSmallHeight || isSmallWidth ? "0.5rem" : "1rem";

    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          backgroundColor: bgColor,
          color: color,
          display: "-webkit-box",
          display: "-webkit-flex",
          display: "-ms-flexbox",
          display: "flex",
          WebkitBoxAlign: "center",
          WebkitAlignItems: "center",
          msFlexAlign: "center",
          alignItems: "center",
          overflow: "hidden",
          margin: 0,
          padding: 0,
        }}
      >
        <style>
          {`
            body { margin: 0; padding: 0; overflow: hidden; }
            @-webkit-keyframes scroll-left {
              0% { -webkit-transform: translateX(0); transform: translateX(0); }
              100% { -webkit-transform: translateX(-50%); transform: translateX(-50%); }
            }
            @keyframes scroll-left {
              0% { -webkit-transform: translateX(0); transform: translateX(0); }
              100% { -webkit-transform: translateX(-50%); transform: translateX(-50%); }
            }
            .ticker-wrapper {
              display: -webkit-box;
              display: -webkit-flex;
              display: -ms-flexbox;
              display: flex;
              width: 100%;
              overflow: hidden;
            }
            .ticker-content {
              display: -webkit-box;
              display: -webkit-flex;
              display: -ms-flexbox;
              display: flex;
              -webkit-animation: scroll-left 20s linear infinite;
              animation: scroll-left 20s linear infinite;
            }
            .ticker-item {
              margin-right: ` +
            gapSize +
            `;
            }
          `}
        </style>
        <div className="ticker-wrapper">
          <div
            className="ticker-content"
            style={{
              fontSize: responsiveFontSize + "px",
              fontWeight: "bold",
              lineHeight: "1",
            }}
          >
            {itemsToRender.concat(itemsToRender).map(function (item, idx) {
              return (
                <div
                  key={idx}
                  className="ticker-item"
                  style={{
                    display: "-webkit-inline-box",
                    display: "-webkit-inline-flex",
                    display: "-ms-inline-flexbox",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    WebkitAlignItems: "center",
                    msFlexAlign: "center",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span style={{ marginRight: marginSize }}>{item.name}</span>
                  <span style={{ marginRight: marginSize }}>{item.price}</span>
                  <span
                    style={{
                      display: "-webkit-inline-box",
                      display: "-webkit-inline-flex",
                      display: "-ms-inline-flexbox",
                      display: "inline-flex",
                      WebkitBoxAlign: "center",
                      WebkitAlignItems: "center",
                      msFlexAlign: "center",
                      alignItems: "center",
                      gap: "0.3rem",
                      color: item.isPositive ? profitColor : lossColor,
                    }}
                  >
                    <i
                      className={
                        item.isPositive ? "bi bi-arrow-up" : "bi bi-arrow-down"
                      }
                      style={{ fontSize: "0.9em" }}
                    />
                    <span>
                      {item.change > 0 ? "+" : ""}
                      {item.change}
                    </span>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Ticker;
